import { okSchema } from '@mio/shared';

import { apiRequest } from '@/shared/api/client';
import { supabase } from '@/shared/lib/supabase';

/** Thin, testable wrapper over Supabase Auth. UI never imports the client directly. */
export const authService = {
  signInWithPassword(email: string, password: string) {
    return supabase.auth.signInWithPassword({ email, password });
  },
  signUp(input: { email: string; password: string; displayName: string }) {
    return supabase.auth.signUp({
      email: input.email,
      password: input.password,
      options: {
        data: { display_name: input.displayName },
        emailRedirectTo: `${window.location.origin}/auth/callback`,
      },
    });
  },
  signInWithGoogle() {
    return supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: `${window.location.origin}/auth/callback` },
    });
  },
  /**
   * Ending the session never depends on the API or the IDE gateway being reachable.
   * IDE grants are revoked when possible and expire on their own otherwise.
   */
  async signOut() {
    await apiRequest('/workshop/ide-access/revoke', okSchema, {
      method: 'POST',
      signal: AbortSignal.timeout(5_000),
    }).catch(() => undefined);
    const result = await supabase.auth.signOut();
    if (!result.error) return result;
    // The refresh token may already be gone server-side; clearing this browser still signs out.
    const local = await supabase.auth.signOut({ scope: 'local' });
    if (local.error) throw local.error;
    return local;
  },
};
